import { render } from "./PageGallery.vue?vue&type=template&id=509050ec&scoped=true"
import script from "./PageGallery.vue?vue&type=script&lang=js"
export * from "./PageGallery.vue?vue&type=script&lang=js"

import "./PageGallery.vue?vue&type=style&index=0&id=509050ec&lang=scss&scoped=true"

import exportComponent from "/tmp/build_c77b6d3d/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509050ec"]])

export default __exports__